import app from 'flarum/common/app';
import Button from 'flarum/common/components/Button';
export default class LoginAsUserButton extends Button {
  view() {
    return m(Button, {
      icon: "fas fa-id-card",
      onclick: this.loginAsUser.bind(this)
    }, app.translator.trans('fof-impersonate.lib.user_controls.impersonate_button'));
  }
  loginAsUser() {
    const {
      user,
      redirectTo
    } = this.attrs;
    app.modal.show(() => import(/* webpackChunkName: 'common/components/ImpersonateModal', webpackMode: 'lazy-once' */ './ImpersonateModal'), {
      callback: () => {
        redirectTo ? window.location.href = redirectTo : window.location.reload();
      },
      user
    });
  }
}
flarum.reg.add('fof-impersonate', 'common/components/LoginAsUserButton', LoginAsUserButton);flarum.reg.addChunkModule('184', '96', 'fof-impersonate', 'common/components/ImpersonateModal');flarum.reg.addChunkModule('184', '96', 'fof-impersonate', 'common/components/ImpersonateModal');